function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSector = function SvgSector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M346.455,269.915v-27.833l-17.297-8.649c-1.418-4.602-3.257-9.018-5.474-13.204l6.118-18.353l-19.681-19.681l-18.353,6.118 c-4.186-2.217-8.603-4.057-13.204-5.474l-8.649-17.297h-27.833l-8.649,17.297c-4.602,1.418-9.018,3.257-13.204,5.474l-18.353-6.118 l-19.681,19.681l6.118,18.353c-2.217,4.186-4.057,8.603-5.474,13.204l-17.297,8.649v27.833l17.297,8.649 c1.418,4.602,3.257,9.018,5.474,13.204l-6.118,18.353l19.681,19.681l18.353-6.118c4.186,2.217,8.603,4.057,13.204,5.474 l8.649,17.297h27.833l8.649-17.297c4.602-1.418,9.018-3.257,13.204-5.474l18.353,6.118l19.681-19.681l-6.118-18.353 c2.217-4.186,4.057-8.603,5.474-13.204L346.455,269.915z M248.594,226.762c2.369-0.598,4.849-0.916,7.404-0.916 c16.653,0,30.152,13.5,30.152,30.152s-13.5,30.152-30.152,30.152s-30.152-13.5-30.152-30.152c0-1.484,0.107-2.943,0.314-4.37"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M128.072,128.073c-32.739,32.739-52.989,77.968-52.989,127.926s20.25,95.187,52.989,127.926"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M170.714,341.283c-21.826-21.826-35.326-51.979-35.326-85.284c0-33.306,13.5-63.458,35.326-85.284"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M341.282,170.715c21.826,21.826,35.326,51.979,35.326,85.284c0,33.305-13.5,63.458-35.326,85.284"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M396.36,141.847c-3.91-4.802-8.062-9.399-12.436-13.774"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M383.924,383.925c32.739-32.739,52.989-77.968,52.989-127.926c0-30.84-7.717-59.879-21.325-85.289"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.998,135.389c33.306,0,63.458,13.5,85.284,35.326l42.642-42.642c-32.739-32.739-77.968-52.989-127.926-52.989 s-95.187,20.25-127.926,52.989l42.642,42.642C192.54,148.889,222.692,135.389,255.998,135.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.998,376.609c-33.305,0-63.458-13.5-85.284-35.326l-42.642,42.642c32.739,32.739,77.968,52.989,127.926,52.989 s95.187-20.25,127.926-52.989l-42.642-42.642C319.456,363.109,289.303,376.609,255.998,376.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M119.285,48.452C51.935,92.905,7.5,169.261,7.5,256h67.583v-0.001"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M255.998,75.084H256V7.5c-37.576,0-73.203,8.339-105.132,23.268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M256,436.914V504.5c137.238,0,248.5-111.262,248.5-248.5h-67.588"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M7.5,256c0,137.238,111.252,248.5,248.5,248.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M504.5,256C504.5,118.752,393.238,7.5,256,7.5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sector.e9b47e50.svg";
export { ForwardRef as ReactComponent };